import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import { getDevice } from './util/helpers-ionic';

const brandColors = {
  blue: 'rgb(0, 0, 238)',
  brandBlue: 'rgb(35,113,192)',
  brandBlueLightened: 'rgb(173, 207, 240)',
  brandGray: 'rgb(96, 97, 98)',
  brandGrayLightened: '#f4f4f4',
  passive: '#f7fafc',
  lightBlue: 'rgb(239, 245, 249)',
  gray: 'rgb(224, 224, 224)',
  black: 'rgb(51, 51, 51)',
  tangerine: 'rgb(255, 130, 0)',
  teal: 'rgb(0,178,169)',
  red: 'rgb(244, 67, 54)',
  white: 'rgb(255, 255, 255)',
};

const getToolbarPaddingTop = () => {
  switch (getDevice()) {
    case 'ios-11-max':
    case 'ios-11Pro':
      return '44px';
    case 'ios-8':
    case 'ios-8-plus':
    case 'ios-generic':
      return '24px';
    case 'ios-se':
      return '20px';
    default:
      return '10px';
  }
};

const getHeaderHeight = () => {
  switch (getDevice()) {
    case 'ios-11-max':
    case 'ios-11Pro':
      return '109px';
    case 'ios-8':
    case 'ios-8-plus':
    case 'ios-generic':
      return '89px';
    case 'ios-se':
      return '85px';
    default:
      return '75px';
  }
};

const appTheme = {
  breakpoints: {
    xsmall: 480,
    small: 481,
    medium: 767,
    large: 961,
    xlarge: 1281,
  },

  system: {
    active: brandColors.brandGray,
    black: brandColors.black,
    border: brandColors.gray,
    link: brandColors.blue,
    passive: brandColors.white,
    passiveHover: brandColors.brandGrayLightened,
    title: brandColors.black,
    white: brandColors.white,
    main: brandColors.passive,
  },

  fonts: {
    sansSerif: '"Open Sans", "Helvetica Neue", Arial, sans-serif',
  },

  sizing: {
    buttonWidth: '180px',
    formBoxMinHeight: '500px',
    formBoxWidth: '400px',
    formMaxWidth: '800px',
    headerHeight: getHeaderHeight(),
    socialButtonWidth: '225px',
    toolbarPaddingTop: getToolbarPaddingTop(),
  },

  spacing: {
    default: '1em',
    small: '8px',
    medium: '16px',
    large: '24px',
    xlarge: '32px',
    xxlarge: '40px',
  },

  margins: {
    sidebar: '240px',
  },
};

const theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: appTheme.breakpoints.xsmall,
      sm: appTheme.breakpoints.small,
      md: appTheme.breakpoints.medium,
      lg: appTheme.breakpoints.large,
      xl: appTheme.breakpoints.xlarge,
    },
  },
  palette: {
    primary: {
      main: appTheme.system.active,
      contrastText: appTheme.system.white,
    },
    secondary: {
      main: appTheme.system.passive,
      contrastText: appTheme.system.black,
    },
  },
  typography: {
    fontFamily: appTheme.fonts.sansSerif,
    useNextVariants: true,
  },
});

export { appTheme };

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js